{
  "name": "axiom",
  "version": "0.52.2",
  "type": "module",
  "author": "Axiom, Inc.",
  "contributors": [
    "Islam Shehata <islam@axiom.co>",
    "Chris Ehrlich <chris@axiom.co>",
    "Gabriel de Andrade <gabriel@axiom.co>"
  ],
  "scripts": {
    "dev": "tsup --watch",
    "build": "tsup && chmod +x dist/bin.js && typedoc && pnpm check:vitest-entrypoints",
    "check:vitest-entrypoints": "node ./scripts/check-vitest-entrypoints.mjs",
    "format": "prettier --write .",
    "format:check": "prettier --check .",
    "lint": "eslint './**/*.{js,ts}'",
    "typecheck": "tsc --noEmit",
    "test": "vitest run",
    "test:watch": "vitest --watch",
    "test:wrangler-smoke": "pnpm build && vitest run --config vitest.smoke.config.ts",
    "publint": "npx publint"
  },
  "types": "./dist/index.d.ts",
  "main": "./dist/index.js",
  "module": "./dist/index.js",
  "bin": {
    "axiom": "./dist/bin.js"
  },
  "exports": {
    "./ai": {
      "types": "./dist/index.d.ts",
      "default": "./dist/index.js"
    },
    "./ai/evals": {
      "types": "./dist/evals.d.ts",
      "default": "./dist/evals.js"
    },
    "./ai/evals/online": {
      "types": "./dist/evals/online.d.ts",
      "default": "./dist/evals/online.js"
    },
    "./ai/scorers": {
      "types": "./dist/scorers/scorers.d.ts",
      "default": "./dist/scorers/scorers.js"
    },
    "./ai/scorers/aggregations": {
      "types": "./dist/scorers/aggregations.d.ts",
      "default": "./dist/scorers/aggregations.js"
    },
    "./ai/config": {
      "types": "./dist/config.d.ts",
      "default": "./dist/config.js"
    },
    "./ai/feedback": {
      "types": "./dist/feedback.d.ts",
      "default": "./dist/feedback.js"
    }
  },
  "keywords": [
    "axiom",
    "logging",
    "ai",
    "otel",
    "opentelemetry"
  ],
  "repository": {
    "type": "git",
    "url": "git+https://github.com/axiomhq/ai.git",
    "directory": "packages/ai"
  },
  "license": "MIT",
  "dependencies": {
    "@next/env": "^15.4.2",
    "@opentelemetry/auto-instrumentations-node": "^0.75.0",
    "@opentelemetry/context-async-hooks": "^2.0.1",
    "@opentelemetry/exporter-trace-otlp-http": "0.217.0",
    "@opentelemetry/resources": "^2.0.1",
    "@opentelemetry/sdk-trace-node": "^2.0.1",
    "@opentelemetry/semantic-conventions": "^1.38.0",
    "@sinclair/typebox": "^0.34.37",
    "c12": "^3.3.3",
    "commander": "^14.0.0",
    "defu": "^6.1.7",
    "handlebars": "^4.7.8",
    "nanoid": "^5.1.5",
    "open": "^10.1.0",
    "vite-tsconfig-paths": "^5.1.4",
    "vitest": "^4.0.0"
  },
  "peerDependencies": {
    "@opentelemetry/api": "^1.9.0",
    "typescript": ">=5.4",
    "zod": "^3.25.0 || ^4.0.0"
  },
  "peerDependenciesMeta": {
    "typescript": {
      "optional": true
    }
  },
  "devDependencies": {
    "@ai-sdk/anthropicv1": "npm:@ai-sdk/anthropic@^1.2.12",
    "@ai-sdk/anthropicv2": "npm:@ai-sdk/anthropic@^2.0.57",
    "@ai-sdk/anthropicv3": "npm:@ai-sdk/anthropic@^3.0.9",
    "@ai-sdk/openaiv1": "npm:@ai-sdk/openai@^1.3.24",
    "@ai-sdk/openaiv2": "npm:@ai-sdk/openai@^2.0.88",
    "@ai-sdk/openaiv3": "npm:@ai-sdk/openai@^3.0.7",
    "@ai-sdk/providerv1": "npm:@ai-sdk/provider@^1.1.3",
    "@ai-sdk/providerv2": "npm:@ai-sdk/provider@^2.0.1",
    "@ai-sdk/providerv3": "npm:@ai-sdk/provider@^3.0.2",
    "@opentelemetry/api": "^1.9.0",
    "@opentelemetry/core": "^2.0.1",
    "@opentelemetry/sdk-trace-base": "^2.0.1",
    "@opentelemetry/sdk-trace-node": "^2.0.1",
    "@repo/eslint-config": "workspace:*",
    "@types/node": "^22.15.29",
    "@vitest/coverage-v8": "^4.0.0",
    "aiv4": "npm:ai@^4.3.19",
    "aiv5": "npm:ai@^5.0.118",
    "aiv6": "npm:ai@^6.0.6",
    "esbuild": "^0.25.8",
    "eslint": "catalog:",
    "msw": "^2.12.2",
    "prettier": "catalog:",
    "tinyrainbow": "^2.0.0",
    "tsup": "catalog:",
    "typedoc": "^0.28.17",
    "typedoc-plugin-markdown": "^4.10.0",
    "typescript": "catalog:",
    "vitest": "catalog:",
    "zod": "catalog:"
  },
  "files": [
    "dist"
  ],
  "packageManager": "pnpm@10.16.1"
}
